export const showActivateSub = (status) =>
  !['active', 'suspended', 'expired'].includes(status);
